import ProductList from "../screens/product/productList/ProductList";
import { adminAccess, supplierAccess, userAccess } from "./useRoleAccess";

export const ProductRoutes = [
  {
    path: "/product",
    route: <ProductList />,
    protectRoutes: true,
    roleGrantAccess: [...adminAccess, ...userAccess, ...supplierAccess]
  }
];
